import React from "react";
import { useTranslation } from "react-i18next";
import PastTripCatchDetailsSection from "./past-trip-catch/PastTripCatchDetailsSection";
import PastTripCatchMediaLocationSection from "./past-trip-catch/PastTripCatchMediaLocationSection";
import usePastTripCatchState from "./past-trip-catch/usePastTripCatchState";

export default function PastTripCatchModal({
  trip,
  userId,
  initialFormState,
  mapPickedCoordinates,
  mapPickSelectionId,
  onPickCoordinatesFromMap,
  onClose,
  onSaved,
}) {
  const { t } = useTranslation();
  const pastTripCatch = usePastTripCatchState({
    trip,
    userId,
    initialFormState,
    mapPickedCoordinates,
    mapPickSelectionId,
    onPickCoordinatesFromMap,
    onClose,
    onSaved,
  });

  return (
    <>
      <div
        className="mytrips-overlay mytrips-trip-catch-overlay"
        onClick={pastTripCatch.handleRequestClose}
      />
      <div
        className="mytrips-panel-card mytrips-trip-catch-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="past-trip-catch-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mytrips-panel-header">
          <h3 id="past-trip-catch-modal-title" className="mytrips-panel-title">
            {t("trip_add_catch_action", {
              defaultValue: "Add Catch",
            })}
          </h3>
          <button
            type="button"
            className="mytrips-panel-close"
            onClick={pastTripCatch.handleRequestClose}
            aria-label={t("cancel", { defaultValue: "Cancel" })}
          >
            {"\u00D7"}
          </button>
        </div>

        <p className="mytrips-trip-catch-intro">
          {t("trip_add_catch_intro", {
            defaultValue:
              "Add a private catch record to this trip. It will appear in this trip's tables, gallery, and analytics without posting to Feed or Profile.",
          })}
        </p>

        {pastTripCatch.tripDateHint && (
          <p className="mytrips-trip-catch-hint">
            {t("trip_add_catch_dates_hint", {
              defaultValue: "Trip dates: {{dates}}",
              dates: pastTripCatch.tripDateHint,
            })}
          </p>
        )}

        {pastTripCatch.error ? (
          <p className="mytrips-trip-catch-error">{pastTripCatch.error}</p>
        ) : null}

        <form
          className="mytrips-trip-catch-form"
          onSubmit={pastTripCatch.handleSubmit}
        >
          <div className="mytrips-trip-catch-grid">
            <PastTripCatchDetailsSection pastTripCatch={pastTripCatch} />
            <PastTripCatchMediaLocationSection pastTripCatch={pastTripCatch} />
          </div>

          <div className="mytrips-trip-catch-actions">
            <button
              type="button"
              className="mytrips-panel-cancel"
              onClick={pastTripCatch.handleRequestClose}
              disabled={pastTripCatch.isSaving}
            >
              {t("cancel", { defaultValue: "Cancel" })}
            </button>
            <button
              type="submit"
              className="mytrips-trip-catch-save"
              disabled={pastTripCatch.isSaving}
            >
              {pastTripCatch.isSaving
                ? t("trip_add_catch_saving", {
                    defaultValue: "Saving...",
                  })
                : t("save", { defaultValue: "Save" })}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
